import { getClient } from "./client";

export type ParticipatedGame = { gameId: string };

export const getGamesParticipated = () =>
  getClient({ authenticate: true })
    .get("/api/games-participated")
    .json<ParticipatedGame[]>();
